import { isNil } from "./types";

export const CONTACT_TYPES_BY_ID = {
    1: { id: 1, title: "words.phone", const: "PHONE" },
    2: { id: 2, title: "words.email", const: "EMAIL" },
};

export const getContactTypeById = (id) => {
    return CONTACT_TYPES_BY_ID[Number(id)] ?? null;
};

export const getContactTypeId = (contact) => {
    const id =
        contact?.contactType?.id ??
        contact?.contactTypeId ??
        contact?.contact_type_id ??
        contact?.contact_type?.id;

    return isNil(id) ? null : Number(id);
};

export const getContactType = (contact) => {
    if (contact?.contactType) return contact.contactType;

    if (contact?.contact_type) {
        return {
            id: Number(contact.contact_type.id),
            title: contact.contact_type.title,
            const: contact.contact_type.const,
        };
    }

    return getContactTypeById(getContactTypeId(contact));
};

export const isPhoneContact = (contact) => {
    return (
        getContactType(contact)?.const === "PHONE" ||
        getContactTypeId(contact) === 1
    );
};

/**
 * Телефон, по которому можно позвонить. Разметку номера не навязываем —
 * скобки, пробелы и дефисы приёмщик набирает как привык, — но буквы и
 * огрызок вроде «+7» номером не считаем: из такого значения выходит мёртвая
 * ссылка tel:. Верхняя граница — длина номера по E.164.
 */
export const isValidPhone = (value) => {
    const raw = String(value ?? "").trim();

    if (!raw) return false;

    if (!/^\+?[\d\s()-]+$/.test(raw)) return false;

    const digits = raw.replace(/\D/g, "");

    return digits.length >= 5 && digits.length <= 15;
};

/**
 * Почта: одна собака, домен с точкой, без пробелов. Больше фронт проверить
 * не может — существование ящика подтверждает только письмо.
 */
export const isValidEmail = (value) => {
    const raw = String(value ?? "").trim();

    return /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(raw);
};

export const isFilledContact = (contact) => {
    if (!contact || isNil(contact.value)) return false;

    const value = String(contact.value).trim();

    if (!value) return false;

    if (isPhoneContact(contact)) {
        const compact = value.replace(/[^\d+]/g, "");
        const digits = value.replace(/\D/g, "");

        return compact !== "+7" && compact !== "7" && digits.length > 1;
    }

    return true;
};

/**
 * Контакт годен к использованию: заполнен и разобран по своему типу. По
 * негодному нельзя ни позвонить, ни написать — ссылку из него не делаем.
 */
export const isValidContact = (contact) => {
    if (!isFilledContact(contact)) return false;

    const value = String(contact.value).trim();

    return isPhoneContact(contact) ? isValidPhone(value) : isValidEmail(value);
};
